import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { routePaths } from '../urls'
import BasePanel from './BasePanel'

export default class Application extends React.Component {
  render() {
    return (
      <div className="position-relative minh-600px">
        <Switch>
          <Route path={routePaths.base_panel} component={BasePanel} />
        </Switch>
      </div>
    )
  }
}
